<template>
  <v-badge
    inline
    color="primary"
    :content="numberElements"
    :value="numberElements"
    bordered
    overlap
  >
    {{ queueTitle }}
  </v-badge>
</template>

<script>
import COUNT_ATTENDANCES from "@/graphql/attendance/count_attendances.gql";

export default {
  name: "PatientsCounter",
  props: {
    queueTitle: String,
    queueType: String,
    attendancePlaceId: {
      type: String,
      default: null,
    },
    employeeId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      countAttendances: 0,
      dayOfAttendance: new Date().toISOString().slice(0, 10),
    };
  },
  computed: {
    numberElements() {
      return this.countAttendances;
    },
  },
  apollo: {
    countAttendances: {
      query: COUNT_ATTENDANCES,
      variables() {
        return {
          queueType: this.queueType,
          attendancePlaceId: this.attendancePlaceId,
          employeeId: this.employeeId,
          dayOfAttendance: this.dayOfAttendance,
        };
      },
      pollInterval: 20000,
    },
  },
  created: function () {
    this.refreshQueue();
  },
  mounted() {
    this.refreshQueue();
  },
  methods: {
    refreshQueue() {
      this.$apollo.queries.countAttendances.refetch();
    },
  },
};
</script>

<style lang="scss" scoped></style>
